const getRegistrationApiUrl = () => {
    const baseUrl = process.env.REACT_APP_BASC_PHP_API_URL?.trim();
    if (!baseUrl) {
        throw new Error('REACT_APP_BASC_PHP_API_URL no está configurada en .env');
    }
    return baseUrl.replace(/\/$/, '');
};

export const submitRegistration = async (formData) => {
    const apiUrl = getRegistrationApiUrl();

    const response = await fetch(`${apiUrl}/POST/landing_registration`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify(formData),
    });

    if (!response.ok) {
        throw new Error('No se pudo enviar el registro. La respuesta de red no fue exitosa.');
    }

    return response.json();
};
